<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{title}}</div>

    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Name">
          <b-input maxlength="255" v-model="item.name"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Code">
          <b-input maxlength="255" v-model="item.code"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column" >
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src

import Vue from 'vue'

const axios = require('axios');


export default {
  name: "SingleMaterial",
  components: {

},
data() {
      return {
          title: "Neues Material anlegen",
          item: {},
          loading: true,
        //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
      }
  },
  watch: {

  },
  mounted: function() {
    console.log("FORM "+ this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Material bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/materials/'+this.$route.params.id, {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.item = response.data;
          _this.loading = false;

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    } else {
        this.loading = false;
    }

  },
  methods: {
    save: function() {
      if ((this.item.name) && (this.item.code)){

        //Set-Package
        var _this = this;
        var url = '/api/materials';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
        .then(function (response) {
          console.log(response.data);
          _this.$router.push({ name: 'materials' })
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
        });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
                      title: 'Fehler',
                      message: 'Bitte füllen Sie alle Felder aus.',
                      type: 'is-danger',
                      hasIcon: true,
                      icon: 'alert-circle',
                      iconPack: 'mdi'
                  });

    }

    }
  }
};

</script>
